const state = {
    /** AB experimentation data */
    experiments: {
        /**
         * String value for the experiment channel. Valid values: 'A','B','C','D'
         */
        channel: null,
        /**
         * Override value for the experiment channel. Used for per-page overrides. Valid values same as above.
         */
        overrideChannel: null,
        /**
         * The date version string for the channel. Format: 'YYMMDD'
         */
        date: null
    }
};

export default state;



// WEBPACK FOOTER //
// ./src/store/ABTest/state.js